<template>
  <div class="contest-leaderboard card inv">
    <div class="leaderboard" v-if="leaderboard">
      <div class="users-list" v-if="leaderboard.items.length">
        <table>
          <thead>
            <tr>
              <td>#</td>
              <td>User</td>
              <td>Games</td>
              <td>Pts</td>
              <td>$</td>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(board, i) in leaderboard.items"
              :key="i"
              :class="{me: (board.user.key === appState.user.key)}"
              >
              <td>{{board.rank}}</td>
              <td>{{board.user.name}}</td>
              <td>{{board.participated_games.length}}</td>
              <td>{{board.points}}</td>
              <td>${{board.chips}}</td>
            </tr>
          </tbody>
        </table>
        <div class="actions">
          <button class="clean small text"
          @click="loadMore()"
          v-if="!state.isLoading() && leaderboard && leaderboard.hasMorePage">Show more</button>
        </div>
      </div>
      <div v-else>
        <div class="no-one">
          <p>No one completed the game!</p>
        </div>
      </div>
    </div>

    <loading-state :state="state"></loading-state>
  </div>
</template>
<script>
import { DataState } from '@/state'
import { ContestLeaderbord } from '@/models/fantasygame/core'

export default {
  props: {
    contestKey: String
  },
  data () {
    return {
      leaderboard: null,
      state: DataState.newLoading()
    }
  },
  mounted () {
    this.fetchData()
  },
  methods: {
    fetchData () {
      if (!this.leaderboard) {
        this.leaderboard = new ContestLeaderbord(this.contestKey)
      }

      this.state.changeToLoading()
      return this.leaderboard.page().then((resp) => {
        this.state.changeToLoaded()
      }).catch((error) => {
        this.state.changeToError(error)
      })
    },

    loadMore () {
      this.fetchData()
    }
  }
}
</script>
